/*
 * Embroidered garments — scroll flourish for the pinned full-viewport panel.
 *
 * The pin itself is pure CSS (.wp-garments-panel { position: sticky }), so this file only adds the
 * scrubbed enhancement: a slow Ken-Burns zoom on the image + a gentle heading parallax, progressing
 * across the exact window the panel is pinned (track top→top until track bottom→bottom).
 *
 * NB: no ScrollTrigger pin (CSS handles that) and no scrub+toggleActions mix — per GSAP best
 * practice. Requires gsap + ScrollTrigger (<head>). <wp-garments-scroll> (display: contents) wraps
 * the track; built in connectedCallback inside gsap.matchMedia() (motion-allowed only — under reduced
 * motion the CSS collapses the track to a plain full-viewport image) and reverted on disconnect.
 */
(function () {
  if (!window.gsap || !window.ScrollTrigger || customElements.get('wp-garments-scroll')) return;

  class WpGarmentsScroll extends HTMLElement {
    connectedCallback() {
      const panel = this.querySelector('[data-garments]');
      if (!panel) return;
      const track = panel.closest('.wp-garments-track') || panel.parentElement;
      const img = panel.querySelector(':scope > img, :scope > svg'); // the background, not the CTA arrow
      const heading = panel.querySelector('[data-garments-heading]');

      this.mm = gsap.matchMedia();
      this.mm.add('(prefers-reduced-motion: no-preference)', () => {
        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: track,
            start: 'top top',
            end: 'bottom bottom',
            scrub: true,
          },
        });

        if (img) tl.fromTo(img, { scale: 1 }, { scale: 1.12, ease: 'none' }, 0);
        if (heading) tl.to(heading, { yPercent: -18, ease: 'none' }, 0);
      });
    }

    disconnectedCallback() {
      if (this.mm) this.mm.revert();
      this.mm = null;
    }
  }

  customElements.define('wp-garments-scroll', WpGarmentsScroll);
})();
